<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col md="12">
        <b-row>
          <b-col sm="5">
            <b-card-group>
              <b-card header="Statistiques des contacts">
                <v-client-table :columns="columns" :data="items" :options="optionsTable">
                  <div v-if="props.row.total" slot="total" slot-scope="props" class="slot-number">
                    <span>{{ props.row.total }}</span>
                  </div>
                </v-client-table>
                <!-- <b-button type="button" variant="primary" @click="largeModal = true" class="mr-1">Chart</b-button> -->
              </b-card>
            </b-card-group>
          </b-col>
          <b-col sm="6">
            <!-- Modal Component -->
            <!-- <<b-modal title="Modal title" class="modal-primary" v-model="largeModal" @ok="largeModal = false"> -->
<!--               <div class="chart-wrapper">
  <chart-contacts :styles="chartStyles" v-if="loaded" :chartdata="chartdata" :options="options" chartId="chart-contacts"/>
</div> -->
            <!-- </b-modal> -->
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import ChartContacts from '../charts/ContactStats'
import { getBaseUrl, getProvider, getIdToken, getAccessToken } from '../../utils/auth'

export default {
  name: "charts",
  components: { ChartContacts },
  data() {
    return {
      loaded: false,
      chartdata: {},
      options: {},
      labels: [],
      data: [],
      backgroundColor: [],
      largeModal: false,
      columns: ["sujet", "total"],
      items: [],
      optionsTable: {
        headings: {
          sujet: "Sujet",
          total: "Total"
        },
        sortable: ["sujet", "total"],
        filterable: ["sujet"],
        perPage: 10,
        perPageValues: [10, 25, 50],
        texts: {
          filterPlaceholder: "Sujet"
        }
      }
    };
  },
  created() {
    this.$axios.defaults.baseURL = getBaseUrl();
    this.$axios.defaults.headers.common["Authorization"] = getIdToken() + " " + getAccessToken();
    this.$axios.defaults.headers.common["Accept"] = "application/json";
    this.$axios.defaults.headers.common["Provider"] = getProvider();
  },
  mounted() {
    this.all();
  },
  methods: {
    all() {
      let self = this;
      this.$store.commit("IS_LOADING", true);
      this.loaded = false;
      this.$axios
        .get("/espaceBeneficiaire/statistiques/contacts")
        .then(response => {
          this.$store.commit("IS_LOADING", false);
          this.items = response.data.contacts;
          let items = response.data.contacts;

          var dynamicColors = function() {
            let color = Math.floor(Math.random() * Math.pow(256, 3)).toString(16);
            return '#' + color;
          };

          for (var i = 0; i < items.length; i++) {
            this.labels.push(items[i].sujet);
            this.data.push(items[i].total);
            this.backgroundColor.push(dynamicColors());
          }

          this.chartdata = {
            labels: this.labels,
            datasets: [
              {
                backgroundColor: this.backgroundColor,
                data: this.data
              }
            ]
          };
          this.options = {
            responsive: true,
            maintainAspectRatio: false,
            legend: { 
              display: false
            },
            tooltips: {
              callbacks: {
                label: function(tooltipItem, data) {
                  var dataset = data.datasets[tooltipItem.datasetIndex];
                  var total = dataset.data.reduce(function(previousValue, currentValue, currentIndex, array) {
                    return previousValue + currentValue;
                  });
                  var currentValue = dataset.data[tooltipItem.index];
                  var percentage = Math.floor(((currentValue/total) * 100)+0.5);     
                  var label = data.labels[tooltipItem.index]
                  return label + " : " + currentValue      
                  //return percentage + "%";
                }
              }
            },
            plugins: {
              labels: [
                // {
                //   render: 'label',
                //   position: 'outside',
                //   overlap: true,
                //   fontColor: '#ffffff'
                // },
                {
                  render: 'percentage',
                  fontColor: '#ffffff',
                  fontSize: 15
                }
              ]
            }
          };
          this.loaded = true;
        })
        .catch(function(error) {
          this.$store.commit("IS_LOADING", false);
          self.$swal({position: "top",type: "error",title: "Attention !!",text: "Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI",showConfirmButton: false,timer: 5000});
        });
    }
  },
  computed: {
    chartStyles () {
      return {
        width: '900px',
        height: '600px'
      }
    }
  }
};
</script>

<style>
</style>
